import { useState } from "react";
import api, { mediaUrl, apiError } from "../../lib/api";
import { UploadCloud, X } from "lucide-react";

export default function ImageUpload({ value, onChange, label = "Image" }) {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");

    const handle = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setUploading(true);
        setError("");
        try {
            const form = new FormData();
            form.append("file", file);
            const { data } = await api.post("/admin/upload", form, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            onChange(data.url);
        } catch (err) {
            setError(apiError(err.response?.data?.detail) || "Upload failed");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <label className="mb-1.5 block text-xs uppercase tracking-[0.15em] text-slate-400/50">
                {label}
            </label>
            {value ? (
                <div className="relative inline-block">
                    <img
                        src={mediaUrl(value)}
                        alt="preview"
                        className="h-40 w-full max-w-xs rounded-xl object-cover ring-1 ring-blue-500/20"
                    />
                    <button
                        type="button"
                        onClick={() => onChange("")}
                        className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-red-500 text-white"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            ) : (
                <label
                    data-testid="image-upload-input"
                    className="flex h-40 max-w-xs cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-blue-500/30 bg-[#070e1c] text-slate-300/60 transition-colors hover:border-blue-400/60"
                >
                    <UploadCloud className="h-6 w-6" />
                    <span className="text-sm">
                        {uploading ? "Uploading…" : "Click to upload"}
                    </span>
                    <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handle}
                        disabled={uploading}
                    />
                </label>
            )}
            {error && <p className="mt-2 text-xs text-red-400">{error}</p>}
        </div>
    );
}
